export const navBarKeys = {
  data: ["NAVIGATION_FLEET", "NAVIGATION_HOME", "NAVIGATION_ABOUT"],
};
export const dateBoxKeys = {
  data: [
    "CALENDAR_PICK_UP_DATE",
    "CALENDAR_PICKUP_UP_LOCATION",
    "CALENDAR_PICKUP_UP_TIME",
    "CALENDAR_DROP_OFF_DATE",
    "CALENDAR_DROP_OFF_LOCATION",
    "CALENDAR_DROP_OFF_TIME",
    "SEARCH",
  ],
};
export const footerValues = {
  data: [
    "SITE_NUMBER",
    "SITE_EMAIL",
    "SITE_INSTAGRAM_LINK",
    "SITE_FACEBOOK_LINK",
    "SETTING_RESERVATION_BACKOFF",
    "SETTING_PAYMENT_METHODS",
  ],
};
export const vehicleValues = {
  data: [
    "CONTACT_US",
    "BOOK",
    "LUGGAGE",
    "TRANSMISSION",
    "FUEL",
    "FILTERS_HEADER",
    "RESERVE",
  ],
};
export const homePageArticles = {
  data: [
    "HOME_PAGE_1",
    "HOME_PAGE_2",
    "HOME_PAGE_3",
    "HOME_PAGE_4",
    "HOME_PAGE_5",
    "HOME_PAGE_6",
    "HOME_PAGE_7",
  ],
};
export const aboutValues = {
  data: ["SITE_NUMBER", "SITE_EMAIL", "SITE_COORDINATES", "SITE_NAME"],
};
export const aboutSettings = {
  data: [
    "LAST_NAME",
    "EMAIL",
    "FIRST_NAME",
    "TELEPHONE",
    "SEND_REQUEST_HEADER",
    "YOUR_MESSAGE",
    "CONTACT_US",
    "CONTACT_PHONE",
    "CONTACT_ADDRESS",
    "CONTACT_EMAIL_SUCCESS",
    "CONTACT_LOCATION_GMAPS",
  ],
};
export const colorPallete = {
  darkBlue: "#06283D",
  midDarkBlue: "#256D85",
  vividLightBlue: "#47B5FF",
  babyBlue: "#DFF6FF",
};
export const euroSign = "€";

export const homePageImages = {
  welcomeToGardeno: "/images/assets/welcome_to_gardeno_car_rental.jpg",
  onlineBooking: "/images/assets/online_booking_gardeno_carental.jpg",
  carRentalFleet: "/images/assets/car_rental_fleet_gardeno_car_rental.jpg",
  exceptionalCustomerService:
    "/images/assets/exceptional_customer_service_gardeno_carental.jpg",
  greatValuePricing: "/images/assets/great_value_pricing_gardeno_carental.jpg",
  convenientPickUp: "/images/assets/convenient_pick_up_gardeno_car_rental.jpg",
  trustInsurance: "/images/assets/trust_insurance_gardeno_carental.jpg",
};
